module.exports = __webpack_public_path__ + "school/img/modelCourseBg.1d69f846.jpg";